// extracted by mini-css-extract-plugin
export var closeButton = "_qa-2";
export var closeButtonIcon = "_qa-3";
export var lightboxContent = "_qa-1";
export var lightboxOverlay = "_qa-0";